"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MachineTechnology = exports.InputFieldType = void 0;
/**
 * The input field types for product mappings. Usually shown for forecasting, and are dependent on which products
 * are released for a given device.
 */
var InputFieldType;
(function (InputFieldType) {
    InputFieldType["PRODUCTION"] = "PRODUCTION";
    InputFieldType["POWER_FEED"] = "POWER_FEED";
    InputFieldType["DAY_AHEAD_COMMITTED_PRODUCTION"] = "DAY_AHEAD_COMMITTED_PRODUCTION";
    InputFieldType["AFRR_POSITIVE"] = "AFRR_POSITIVE";
    InputFieldType["AFRR_NEGATIVE"] = "AFRR_NEGATIVE";
    InputFieldType["AFRR_LOWER_LIMIT"] = "AFRR_LOWER_LIMIT";
    InputFieldType["AFRR_UPPER_LIMIT"] = "AFRR_UPPER_LIMIT";
    InputFieldType["MFRR_POSITIVE"] = "MFRR_POSITIVE";
    InputFieldType["MFRR_NEGATIVE"] = "MFRR_NEGATIVE";
    InputFieldType["MFRR_LOWER_LIMIT"] = "MFRR_LOWER_LIMIT";
    InputFieldType["MFRR_UPPER_LIMIT"] = "MFRR_UPPER_LIMIT";
    InputFieldType["FCR"] = "FCR";
    InputFieldType["FLEX_PLUS_LOWER_LIMIT"] = "FLEX_PLUS_LOWER_LIMIT";
    InputFieldType["FLEX_PLUS_UPPER_LIMIT"] = "FLEX_PLUS_UPPER_LIMIT";
})(InputFieldType || (exports.InputFieldType = InputFieldType = {}));
var MachineTechnology;
(function (MachineTechnology) {
    MachineTechnology["OTHER"] = "OTHER";
    MachineTechnology["CONVENTIONAL"] = "CONVENTIONAL";
    MachineTechnology["BIOGAS"] = "BIOGAS";
    MachineTechnology["SOLAR"] = "SOLAR";
    MachineTechnology["WIND"] = "WIND";
    MachineTechnology["WATER"] = "WATER";
    MachineTechnology["BATTERY"] = "BATTERY";
    MachineTechnology["BIOMASS"] = "BIOMASS";
    MachineTechnology["COMPOSITE"] = "COMPOSITE";
})(MachineTechnology || (exports.MachineTechnology = MachineTechnology = {}));
